import { gql } from '@edreamsodigeo/frontend-api-client';

export const api = gql`
  fragment FeeTypeInfo on FeeType {
    id
    name
    paymentMethod
  }
`;
